// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog_tdYZ8 {
  max-width: 496px;
  min-height: 368px;
  display: flex;
  flex-direction: column;
}

.button_Rv2AC {
  min-width: 128px;
}

.dialogHeader_Lhaln {
  padding: var(--size-pad12) var(--size-padLarge);
  border-bottom: 1px solid var(--color-base100);
}

.headerIcon_B9oQQ {
  background-color: #D0EBFF;
  width: 24px;
  height: 24px;
}
.headerIcon_B9oQQ > i {
  font-size: 10px;
}

.dialogBody_wBcg_ {
  flex: 1;
  padding: var(--size-padXLarge);
  background-color: var(--color-base050);
}
.dialogBody_wBcg_ > * + * {
  margin-top: var(--size-padLarge);
}

.dialogFooter_N9dQf {
  padding: var(--size-padLarge);
  border-top: 1px solid var(--color-base100);
}

.formLabel_GFbuj {
  margin-bottom: var(--size-padSmall);
}

/* Overriding default Toast's styling */
.toast_nhMwr {
  border-radius: var(--size-borderRadiusMedium) !important;
  min-height: 40px !important;
  padding: var(--size-padMedium) !important;
}
.toast_nhMwr > button {
  margin-top: 0 !important;
  width: 24px !important;
  height: 24px !important;
}

.icon_pfoc3 {
  width: 24px;
  margin-left : 8px;
  margin-right : 8px;
}

.input_aBBUg {
  padding-left : 0px;
}

.selector__07GZ {
  width: 100%;
  background-color: white !important;
}

.radioButton_u3_EB {
  background-color: var( --color-white );
  border-radius : 50%;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/recovrGeneric/ownershipTransfer/actions/completeAssetTransfer/EnableDataSharingClasses.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,8BAA8B;EAC9B,sCAAsC;AACxC;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC;;AAEA,uCAAuC;AACvC;EACE,wDAAwD;EACxD,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB","sourcesContent":[".dialog {\n  max-width: 496px;\n  min-height: 368px;\n  display: flex;\n  flex-direction: column;\n}\n\n.button {\n  min-width: 128px;\n}\n\n.dialogHeader {\n  padding: var(--size-pad12) var(--size-padLarge);\n  border-bottom: 1px solid var(--color-base100);\n}\n\n.headerIcon {\n  background-color: #D0EBFF;\n  width: 24px;\n  height: 24px;\n}\n.headerIcon > i {\n  font-size: 10px;\n}\n\n.dialogBody {\n  flex: 1;\n  padding: var(--size-padXLarge);\n  background-color: var(--color-base050);\n}\n.dialogBody > * + * {\n  margin-top: var(--size-padLarge);\n}\n\n.dialogFooter {\n  padding: var(--size-padLarge);\n  border-top: 1px solid var(--color-base100);\n}\n\n.formLabel {\n  margin-bottom: var(--size-padSmall);\n}\n\n/* Overriding default Toast's styling */\n.toast {\n  border-radius: var(--size-borderRadiusMedium) !important;\n  min-height: 40px !important;\n  padding: var(--size-padMedium) !important;\n}\n.toast > button {\n  margin-top: 0 !important;\n  width: 24px !important;\n  height: 24px !important;\n}\n\n.icon {\n  width: 24px;\n  margin-left : 8px;\n  margin-right : 8px;\n}\n\n.input {\n  padding-left : 0px;\n}\n\n.selector {\n  width: 100%;\n  background-color: white !important;\n}\n\n.radioButton {\n  background-color: var( --color-white );\n  border-radius : 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `dialog_tdYZ8`,
	"button": `button_Rv2AC`,
	"dialogHeader": `dialogHeader_Lhaln`,
	"headerIcon": `headerIcon_B9oQQ`,
	"dialogBody": `dialogBody_wBcg_`,
	"dialogFooter": `dialogFooter_N9dQf`,
	"formLabel": `formLabel_GFbuj`,
	"toast": `toast_nhMwr`,
	"icon": `icon_pfoc3`,
	"input": `input_aBBUg`,
	"selector": `selector__07GZ`,
	"radioButton": `radioButton_u3_EB`
};
export default ___CSS_LOADER_EXPORT___;
